<template lang="pug">
.jumbotron.jumbotron-fluid.text-white.bg-dark.mb-0(
  :style="{ backgroundImage: 'url(' + background + ')' }"
)
  .container
    .title.text-center.p-5
      h4.display-4.text-white {{ title }}
</template>

<script>
export default {
  name: "Banner",
  props: {
    background: String,
    title: String,
  },
};
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 959px) {
  .jumbotron .display-4 {
    font-size: 2rem;
  }
}
</style>
